import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {StatusPage} from "../StatusPage";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {DateTime} from "../../components/ListComponent/DateTime";
import {Util} from "../../components/Util";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";

export class SnapshotCompare extends ListComponent {
    protected limit: number = 250;

    protected getRequestUrl(): RequestInfo | URL {
        return '/product/snapshot-compare';
    }

    render() {
        if (this.state?.code && this.state?.message) {
            return <StatusPage code={this.state.code} message={this.state.message}/>;
        }

        const params: {} | any = this.getFormData();

        return (
            <>
                <div className="row">
                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <h5>{this.dictionary.get['search']}</h5>

                            <div className="col-md-12 sub-details">
                                <div className="row">
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'product_id', defaultValue: params?.product_id}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Select {...{
                                            id: 'diff',
                                            basic: 'show-all',
                                            items: ['sales', 'warehouse', 'warehouse_missing', 'warehouse_damaged', 'provider_missing', 'provider_damaged', 'wh-provider-sales-complex', 'very-complex', 'warehouse-sales'],
                                            defaultValue: params?.diff
                                        }}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Select {...{
                                            id: 'has',
                                            basic: 'show-all',
                                            items: ['sales', 'warehouse', 'warehouse_missing', 'warehouse_damaged', 'provider_missing', 'provider_damaged', 'warehouse-sales'],
                                            defaultValue: params?.has
                                        }}/>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <FormGroup.Select {...{
                                            id: 'not',
                                            basic: 'show-all',
                                            items: ['sales', 'warehouse', 'warehouse_missing', 'warehouse_damaged', 'provider_missing', 'provider_damaged', 'wh-provider-sales-complex', 'very-complex', 'warehouse-sales'],
                                            defaultValue: params?.not
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'p.id:a'}/>
                        {this.listOfSearchParams(params)}
                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/product/snapshot-compare-export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['snapshot-history']}: &nbsp;
                                    <strong>{this.state.count ? <FormattedNumber
                                        value={this.state.count}/> : '-'}</strong> {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                        <div className="row" style={{marginBottom: '10px'}}>


                            <div className="col-md-4">
                                Total:&nbsp;
                                {0 < this.state?.item?.quantity && <strong><FormattedNumber
                                    value={this.state.item.quantity}/>&nbsp;(pc)</strong>}
                                {!this.state?.item?.quantity && <span>-</span>}
                            </div>
                            <div className="col-md-4">
                                Isolated:&nbsp;
                                {0 < this.state?.item?.isolated_quantity && <strong><FormattedNumber
                                    value={this.state.item.isolated_quantity}/>&nbsp;(pc)</strong>}
                                {!this.state?.item?.isolated_quantity && <span>-</span>}
                            </div>
                            <div className="col-md-4">
                                TransferIN:&nbsp;
                                {0 < this.state?.item?.transfer_in_quantity && <strong><FormattedNumber
                                    value={this.state.item.transfer_in_quantity}/>&nbsp;(pc)</strong>}
                                {!this.state?.item?.transfer_in_quantity && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Sales:&nbsp;
                                {0 < this.state?.item?.provider_sales_quantity && <strong><FormattedNumber
                                    value={this.state.item.provider_sales_quantity}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.provider_sales_quantity && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Sales Diff:&nbsp;
                                {0 < this.state?.item?.sales_diff && <strong><FormattedNumber
                                    value={this.state.item.sales_diff}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.sales_diff && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Warehouse:&nbsp;
                                {0 < this.state?.item?.warehouse_quantity && <strong><FormattedNumber
                                    value={this.state.item.warehouse_quantity}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.warehouse_quantity && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Warehouse Diff:&nbsp;
                                {0 < this.state?.item?.warehouse_quantity_diff && <strong><FormattedNumber
                                    value={this.state.item.warehouse_quantity_diff}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.warehouse_quantity_diff && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Warehouse Sales Diff:&nbsp;
                                {0 < this.state?.item?.warehouse_sales_diff && <strong><FormattedNumber
                                    value={this.state.item.warehouse_sales_diff}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.warehouse_sales_diff && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Damaged:&nbsp;
                                {0 < this.state?.item?.damaged_quantity && <strong><FormattedNumber
                                    value={this.state.item.damaged_quantity}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.damaged_quantity && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Damaged WH:&nbsp;
                                {0 < this.state?.item?.warehouse_damaged_quantity && <strong><FormattedNumber
                                    value={this.state.item.warehouse_damaged_quantity}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.warehouse_damaged_quantity && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Damaged Diff:&nbsp;
                                {0 < this.state?.item?.warehouse_damaged_diff && <strong><FormattedNumber
                                    value={this.state.item.warehouse_damaged_diff}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.warehouse_damaged_diff && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Damaged:&nbsp;
                                {0 < this.state?.item?.provider_damaged_quantity && <strong><FormattedNumber
                                    value={this.state.item.provider_damaged_quantity}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.provider_damaged_quantity && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Damaged Diff:&nbsp;
                                {0 < this.state?.item?.provider_damaged_diff && <strong><FormattedNumber
                                    value={this.state.item.provider_damaged_diff}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.provider_damaged_diff && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Missing:&nbsp;
                                {0 < this.state?.item?.missing_quantity && <strong><FormattedNumber
                                    value={this.state.item.missing_quantity}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.missing_quantity && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Missing WH:&nbsp;
                                {0 < this.state?.item?.warehouse_missing_quantity && <strong><FormattedNumber
                                    value={this.state.item.warehouse_missing_quantity}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.warehouse_missing_quantity && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Missing Diff:&nbsp;
                                {0 < this.state?.item?.warehouse_missing_diff && <strong><FormattedNumber
                                    value={this.state.item.warehouse_missing_diff}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.warehouse_missing_diff && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Missing WH:&nbsp;
                                {0 < this.state?.item?.provider_missing_quantity && <strong><FormattedNumber
                                    value={this.state.item.provider_missing_quantity}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.provider_missing_quantity && <span>-</span>}
                            </div>

                            <div className="col-md-4">
                                Missing Diff:&nbsp;
                                {0 < this.state?.item?.provider_missing_diff && <strong><FormattedNumber
                                    value={this.state.item.provider_missing_diff}/>&nbsp;(abs)</strong>}
                                {!this.state?.item?.provider_missing_diff && <span>-</span>}
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="p.`id`"
                                    colSpan={1}>{this.dictionary.get['product_id']}</th>
                                <th className="sortable"
                                    data-sortkey="p.`name`">{this.dictionary.get['product_name']}</th>
                                <th className="sortable" data-sortkey="p.`sku`">{this.dictionary.get['sku']}</th>

                                <th className="sortable" data-sortkey="(p.`quantity`)">Total</th>
                                <th className="sortable" data-sortkey="p.`isolated_quantity`">Isolated</th>
                                <th className="sortable" data-sortkey="p.`transfer_in_quantity`">TransferIN</th>

                                <th className="sortable" data-sortkey="p.`provider_sales_quantity`">Sales</th>
                                <th className="sortable"
                                    data-sortkey="(p.`quantity`-p.`provider_sales_quantity`)">
                                    Sales Diff
                                </th>

                                <th className="sortable" data-sortkey="p.`warehouse_quantity`">Warehouse quantity</th>
                                <th className="sortable"
                                    data-sortkey="p.`warehouse_quantity_diff`">Warehouse
                                    Diff
                                </th>
                                <th className="sortable"
                                    data-sortkey="(p.`provider_sales_quantity`-p.`warehouse_quantity`)">Warehouse
                                    Sales Diff
                                </th>

                                <th className="sortable" data-sortkey="p.`damaged_quantity`">Damaged</th>
                                <th className="sortable" data-sortkey="p.`warehouse_damaged_quantity`">Damaged WH</th>
                                <th className="sortable"
                                    data-sortkey="(p.`warehouse_damaged_quantity`-p.`damaged_quantity`)">Damaged WH Diff
                                </th>
                                <th className="sortable" data-sortkey="p.`provider_damaged_quantity`">Damaged Provider
                                </th>
                                <th className="sortable"
                                    data-sortkey="(p.`provider_damaged_quantity`-p.`damaged_quantity`)">Damaged Provider
                                    Diff
                                </th>

                                <th className="sortable" data-sortkey="p.`missing_quantity`">Missing</th>
                                <th className="sortable" data-sortkey="p.`warehouse_missing_quantity`">Missing WH</th>
                                <th className="sortable"
                                    data-sortkey="(p.`warehouse_missing_quantity`-p.`missing_quantity`)">Missing Diff
                                </th>
                                <th className="sortable" data-sortkey="p.`provider_missing_quantity`">Missing Provider
                                </th>
                                <th className="sortable"
                                    data-sortkey="(p.`provider_missing_quantity`-p.`missing_quantity`)">Missing Provider
                                    Diff
                                </th>

                                <th className="sortable" data-sortkey="p.updated_at">
                                    {this.dictionary.get['updated_at']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                const productLink: string = '/product/details/' + elem.product_id;

                                const total = elem.quantity;
                                const salesDiff = elem.provider_sales_quantity - total;

                                let whSales = elem.provider_sales_quantity - elem.warehouse_quantity;


                                const damagedWhDiff = (elem.warehouse_damaged_quantity || 0) - (elem.damaged_quantity || 0);
                                const missingWhDiff = (elem.warehouse_missing_quantity || 0) - (elem.missing_quantity || 0);

                                const damagedProDiff = (elem.provider_damaged_quantity || 0) - (elem.damaged_quantity || 0);
                                const missingProDiff = (elem.provider_missing_quantity || 0) - (elem.missing_quantity || 0);

                                return (
                                    <tr key={elem.product_id} data-id={elem.product_id}>
                                        <td>{Util.link(elem.product_id, productLink)}</td>
                                        <td>{elem.product_name}</td>
                                        {Util.searchCell(elem.sku, 'sku')}

                                        <td>{total ? FormattedNumber.format(total) : '-'}</td>
                                        <td>{elem.isolated_quantity ? FormattedNumber.format(elem.isolated_quantity) : '-'}</td>
                                        <td>{elem.transfer_in_quantity ? FormattedNumber.format(elem.transfer_in_quantity) : '-'}</td>

                                        <td>{elem.provider_sales_quantity ? FormattedNumber.format(elem.provider_sales_quantity) : '-'}</td>
                                        <td>{salesDiff ? FormattedNumber.format(salesDiff) : '-'}</td>

                                        <td>{elem.warehouse_quantity ? FormattedNumber.format(elem.warehouse_quantity) : '-'}</td>
                                        <td>{elem.warehouse_quantity_diff ? (0 < elem.warehouse_quantity_diff ? '+' : '') + FormattedNumber.format(elem.warehouse_quantity_diff) : '-'}</td>
                                        <td>{whSales ? FormattedNumber.format(whSales) : '-'}</td>

                                        <td>{elem.damaged_quantity ? FormattedNumber.format(elem.damaged_quantity) : '-'}</td>

                                        <td>{elem.warehouse_damaged_quantity ? FormattedNumber.format(elem.warehouse_damaged_quantity) : '-'}</td>
                                        <td>{damagedWhDiff ? FormattedNumber.format(damagedWhDiff) : '-'}</td>

                                        <td>{elem.provider_damaged_quantity ? FormattedNumber.format(elem.provider_damaged_quantity) : '-'}</td>
                                        <td>{damagedProDiff ? FormattedNumber.format(damagedProDiff) : '-'}</td>


                                        <td>{elem.missing_quantity ? FormattedNumber.format(elem.missing_quantity) : '-'}</td>

                                        <td>{elem.warehouse_missing_quantity ? FormattedNumber.format(elem.warehouse_missing_quantity) : '-'}</td>
                                        <td>{missingWhDiff ? FormattedNumber.format(missingWhDiff) : '-'}</td>

                                        <td>{elem.provider_missing_quantity ? FormattedNumber.format(elem.provider_missing_quantity) : '-'}</td>
                                        <td>{missingProDiff ? FormattedNumber.format(missingProDiff) : '-'}</td>

                                        <td><DateTime value={elem.updated_at} inline={true}/></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={13}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
